module.exports = __webpack_public_path__ + "static/media/check-circle.ce63c045.svg";